/**
 * Assistance back-office — page d'information. Contacts internes BCL,
 * lien vers la documentation, etc. Pas d'API spécifique.
 */
import { MessageSquare, Phone, BookOpen } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { DashboardLayout } from '@/components/dashboard/dashboard-layout';

export function AdminAssistancePage() {
  return (
    <DashboardLayout variant="admin" title="Assistance">
      <div className="grid gap-4 lg:grid-cols-3">
        <Card>
          <CardHeader className="flex flex-row items-start gap-3">
            <Phone className="h-5 w-5 text-bcl-blue" />
            <div>
              <CardTitle className="text-base">Support technique</CardTitle>
              <CardDescription>
                Joignez l&apos;équipe technique BCL au +33 1 00 00 00 00.
              </CardDescription>
            </div>
          </CardHeader>
        </Card>
        <Card>
          <CardHeader className="flex flex-row items-start gap-3">
            <MessageSquare className="h-5 w-5 text-bcl-blue" />
            <div>
              <CardTitle className="text-base">Messagerie interne</CardTitle>
              <CardDescription>
                Messagerie Slack #ops-bcl (à connecter).
              </CardDescription>
            </div>
          </CardHeader>
        </Card>
        <Card>
          <CardHeader className="flex flex-row items-start gap-3">
            <BookOpen className="h-5 w-5 text-bcl-blue" />
            <div>
              <CardTitle className="text-base">Documentation</CardTitle>
              <CardDescription>
                Procédures internes, scripts SQL, guides opérateurs.
              </CardDescription>
            </div>
          </CardHeader>
        </Card>
      </div>

      <Card className="mt-6">
        <CardHeader>
          <CardTitle>Procédures rapides</CardTitle>
          <CardDescription>
            Les actions les plus fréquentes du back-office.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ul className="space-y-2 text-sm">
            <li>
              <strong>Valider un dossier client&nbsp;:</strong> Dossiers → ouvrez
              le dossier → vérifiez les documents (Documents) → confirmez le
              paiement (Paiements).
            </li>
            <li>
              <strong>Refuser un document&nbsp;:</strong> Documents → ligne du
              document → saisissez un motif → cliquez sur la croix rouge.
            </li>
            <li>
              <strong>Affecter un dossier à un technicien&nbsp;:</strong> Planning
              → formulaire de droite → sélectionnez le technicien, la date, la
              durée.
            </li>
            <li>
              <strong>Promouvoir un admin (super-admin)&nbsp;:</strong> Équipe
              BCL → modifiez le rôle dans la liste, puis confirmez.
            </li>
          </ul>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}
